<template>
  <div class="cc-carrier" v-if="display" @click="showBranches = true">
    <div class="cc-carrier__selector">
      <div class="cc-selector cc-selector--medium cc-selector--radio" v-bind:class="{'cc-active': selected}"></div>
    </div>
    <div class="cc-carrier__thumbnail" v-if="carrierImage">
      <img :src="carrierImage" :alt="carrierName" class="cc-carrier__image">
    </div>
    <div class="cc-carrier__information" v-bind:class="{'cc-thumbnail-exists': carrierImage}">
      <div class="cc-carrier__title cc-title cc-title--carrier">{{ carrierName }}</div>
      <div class="cc-carrier__subtitle cc-subtitle cc-subtitle--carrier">{{ translations['Select store'] }}</div>
      <div class="cc-carrier__grouped-pickup-in-store">
        <select-store
            :carriers="carriers"
            :showBranches="showBranches"
            :selectedCarrier="selectedCarrier"
            :currentCarrier="currentCarrier"
            @selectCarrier="setCarrier"
            @closeWithoutParcelShop="unsetCarrier"
            @close="showBranches = false"
            @onShowBranches="showBranches = true"
        />
      </div>
      <div class="cc-carrier__packetery" v-if="showPickupDate">
        <pickup-date :carrier="currentCarrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
    </div>
    <div class="cc-carrier__prices">
      <div class="cc-price cc-price--carrier">{{ price }}</div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import GlsParcelShop from "@/components/Store919/GlsParcelShop";
import ShaimBalikovna from "@/components/_common/modules/shaim_balikovna/ShaimBalikovna";
import ShaimBalikNaPostu from "@/components/_common/modules/shaim_baliknapostu/ShaimBalikNaPostu";
import PickupDate from "@/components/_common/PickupDate/PickupDate";
import SelectStore from "@/components/_common/SelectStore/SelectStore";

export default {
  components: {
    SelectStore,
    PickupDate,
    ShaimBalikNaPostu,
    ShaimBalikovna,
    GlsParcelShop
  },
  computed: {
    ...mapState({
      translations: state => state.translations,
      selectedCarrier: state => state.selectedCarrier,
      currentCarrier: state => state.currentCarrier,
      user: state => state.user,
      packetery: state => state.packetery,
      packetery_v213: state => state.packetery_v213,
      useVat: state => state.config.use_vat,
      shaim_zasilkovna_widget: state => state.shaim_zasilkovna_widget,
      config: state => state.config,
    }),
    carrierImage: function () {
      return this.carriers[0].img;
    },
    carrierName: function () {
      return this.translations['Pickup in store'];
    },
    price: function () {
      return this.translations['Free'];
    },
    display: function () {
      return (!this.selectedCarrier || this.selected) && this.carriers && this.carriers.length > 0;
      // return (!this.selectedCarrier || this.selected);
      },
    selected: function () {
      return this.carriers.map(carrier => carrier.id_carrier).includes(this.selectedCarrier);
    },
    pickupInStore: function () {
      return this.currentCarrier && this.currentCarrier.pickupInStore;
    },
    showPickupDate: function () {
      if (!this.selectedBranch) {
        return false;
      }
      return this.selectedBranch.extra.show_pickup_date
    }
  },
  data () {
    return {
      showBranches: false,
      selectedBranch: null,
    }
  },
  methods: {
    unsetCarrier: function () {
      this.$store.dispatch('SELECT_CARRIER', null);
      this.$store.dispatch('SELECT_PAYMENT', null);
      this.showBranches = false;
    },
    setCarrier: function (carrier) {
      this.showBranches = false;
      this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(function () {
        if (window.innerWidth < 1200) {
          document.querySelector('.cc-carriers').scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          document.querySelector('.cc-theme').scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
  },
  props: [
    'carriers',
  ],
};
</script>

<style lang="scss" scoped="scoped">
@import "./scss/components/carrier";
.cc-carrier__grouped-pickup-in-store {
  font-size: 14px;
  width: auto;
  padding: 0 1rem 2rem;
  display: inline-block;
}
</style>
